import { defineCustomElement } from 'vue';
import './index.scss';
import ClawGame from '../../../../shared/components/claw-game/claw-game.ce.vue';

const ClawGameElement = defineCustomElement(ClawGame);
customElements.define('claw-game', ClawGameElement);
